import { render, staticRenderFns } from "./icon-calendar.vue?vue&type=template&id=237bbdf6&"
import script from "./icon-calendar.vue?vue&type=script&lang=js&"
export * from "./icon-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Third Coast Creative/repos/MidwestBeltone.Iframes/MidwestBeltone.Iframes.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237bbdf6')) {
      api.createRecord('237bbdf6', component.options)
    } else {
      api.reload('237bbdf6', component.options)
    }
    module.hot.accept("./icon-calendar.vue?vue&type=template&id=237bbdf6&", function () {
      api.rerender('237bbdf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-calendar.vue"
export default component.exports